import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Visita/imprimirVisita`, method: 'POST', body: values, token: token})
}
